module.exports = "<svg viewBox=\"0 0 143.8 145.8\"><path fill=\"#1E1E1C\" d=\"M2.9 145.8c-2 0-3.4-2-2.7-3.9 9.3-24.2 37.9-41.8 71.7-41.8 33.8 0 62.4 17.6 71.7 41.8.7 1.9-.7 3.9-2.7 3.9H2.9z\"></path><circle cx=\"71.9\" cy=\"39\" r=\"39\" fill=\"#1E1E1C\"></circle></svg>"


//////////////////
// WEBPACK FOOTER
// ./svgs/offer-audiences.svg
// module id = 238
// module chunks = 1